import { getStore } from '~/mobx/AppStore';

export const onChangeElection = (id: string) => {
    const { generalSettingsStore, adminStore } = getStore();

    // Find company with matching ID
    const selectedElection = generalSettingsStore.electionList?.find((election) => election?.id === id) || null;

    // Update stores
    adminStore.setElectionToCopy(selectedElection);
};
